export default __webpack_public_path__ + "static/media/technicalDesc.97719c2c.png";